<template>
  <Navbar />
  <ScrollButton />

  <section class="banner-title" style="background-image: url(images/color.png)">
    <div class="auto-container">
      <div class="row clearfix">
        <div class="title-column col-md-6 col-sm-6 col-xs-12">
          <h1>Değerlerimiz</h1>
        </div>
        <div class="col-md-6 col-sm-6 col-xs-12">
          <ul class="bread-crumb clearfix">
            <li><a href="/">Anasayfa</a></li>
            <li class="active">Değerlerimiz</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="page-container">
    <div class="auto-container">
      <div class="text-content">
        <div class="left-text">
          <blockquote>
             <p>
                      Elektronik sektöründeki <strong>uzun yıllara dayanan tecrübemizi</strong>,
                      modern tasarım anlayışı ve güncel <strong>üretim teknolojileri</strong> ile birleştiriyoruz.
                      Müşterilerimize sunduğumuz her <strong>kontrol kartı</strong> ve her proje,
                      kaliteye ve güvene verdiğimiz önemin bir yansımasıdır.
                    </p>

          <p class="mt-2">
                      Teknolojideki küresel gelişmeleri yakından takip ederek,
                      <strong>elektronik kart tasarımı</strong> ve üretim süreçlerimizi sürekli geliştiriyoruz.
                      Bugün ürünlerimizi hem <strong>yurt içi</strong> hem de <strong>yurt dışı pazarlarda</strong> görmekten büyük bir gurur duyuyoruz.
                    </p>

             <p class="mt-2">
                      <strong>Kalite, güvenilirlik ve sürdürülebilirlik</strong> ilkeleriyle
                      faaliyet gösteren firmamız, geleceğe sağlam adımlarla ilerlemeye devam ediyor.
                    </p>
          </blockquote>
        </div>
        <div class="right-img">
          <img class="value-img" src="images/prototip.jpg" alt="İntek Electronic kontrol kartı üretimi" loading="lazy" />
        </div>
      </div>
    </div>
  </section>

  <Footer />
</template>

<script setup>
import { useHead } from '@vueuse/head';
import Navbar from "@/components/Navbar-2.vue";
import ScrollButton from "@/components/ScrollButton.vue";
import Footer from "@/components/Footer.vue";

useHead({
  title: 'Değerlerimiz - İntek Electronic | Kalite, Güven, Teknoloji',
  meta: [
    {
      name: 'description',
      content: 'İntek Electronic olarak, elektronik kart tasarımı ve üretiminde kalite, güvenilirlik ve teknoloji odaklı değerlerimizi her projeye yansıtıyoruz.'
    },
    {
      name: 'keywords',
      content: 'intek, intek elektronik, değerlerimiz, kalite, güvenilirlik, teknoloji, elektronik kontrol kartları, üretim, tasarım'
    },
    {
      property: 'og:title',
      content: 'Değerlerimiz - İntek Electronic'
    },
    {
      property: 'og:description',
      content: 'Kalite, güven ve teknolojiye dayalı üretim anlayışımızla elektronik sektöründe fark yaratıyoruz.'
    },
    {
      property: 'og:image',
      content: 'https://www.intekelectronic.com.tr/images/prototip.jpg'
    }
  ]
});
</script>

<style scoped>

.text-content {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 40px;
}

.left-text {
  flex: 1 1 400px;
}

.right-img {
  flex: 1 1 320px;
  display: flex;
  justify-content: center;
}

.value-img {
  width: 100%;
  max-width: 460px;
  height: auto;
  border-radius: 8px;
}
/* Mobil uyum */
@media (max-width: 768px) {
  .text-content {
    flex-direction: column;
    align-items: center;
    text-align: left;
  }
}
</style>
